
import { AdminPDFPreview } from "./AdminPDFPreview";
import { UserTraining } from "./UserTraining";
import { useTrainingSession } from "./hooks/useTrainingSession";

interface PDFPreviewProps {
  resourceId: string;
  topic?: string;
  company?: string;
  onComplete?: () => void;
}

export function PDFPreview({ resourceId, topic = "Training", company = "Company", onComplete }: PDFPreviewProps) {
  const { isTrainee, isAdmin } = useTrainingSession();
  
  console.log("PDFPreview router - isAdmin:", isAdmin, "isTrainee:", isTrainee);
  
  // Route to the appropriate component based on user role
  if (isTrainee) {
    return (
      <UserTraining 
        resourceId={resourceId}
        topic={topic} 
        company={company}
        onComplete={onComplete}
      />
    );
  }
  
  // Default to admin view 
  return (
    <AdminPDFPreview
      resourceId={resourceId}
      topic={topic} 
      company={company}
      onComplete={onComplete}
    />
  );
}
